import Resource from '@/api/resources/Resource'

class DiagnosisCaseFilterServices extends Resource {
    async getAllCases(laboratoryId, filterModel, params) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases/allCases`, filterModel, { params })
        return response.data
    }
    async getAllCasesSummary(filterModel, laboratoryId) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases/allCasesSummary`, filterModel)
        const summary = {}
        response.data.forEach(element => {
            summary[element.filterName] = element.filterCount
        })
        return summary
    }
    async getMyOwnCases(laboratoryId, filterModel, params) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases/myOwnCases`, filterModel, { params })
        return response.data
    }
    async getMyOwnCasesSummary(filterModel, laboratoryId, params) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases/myOwnCasesSummary`, filterModel, { params })
        const summary = {}
        response.data.forEach(element => {
            summary[element.filterName] = element.filterCount
        })
        return summary
    }
    async getConsultationsCasesSummary(filterModel, laboratoryId) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases/casesWithConsultationSummary`, filterModel)
        const summary = {}
        response.data.forEach(element => {
            summary[element.filterName] = element.filterCount
        })
        return summary
    }

    async getConsultationsCases(laboratoryId, filterModel, params, url) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases/${url}`, filterModel, { params })
        return response.data
    }
}

export default new DiagnosisCaseFilterServices()
